import { store }  from '@/store/index.js'
import { vehicleSignalNamesByEcus, engineSignalNamesByEcus } from '@/services/importingJsons.js'

const freezeFrames = {
  namespaced: true,
  state: {
    allEcusSelected: false,
    signals: {
      options: [],
      loading: false,
      error: false
    },
    selected: {
      customReportLink: null,
      signals: [],
      ecuTypeActive: '',
      ecuProperties: {
        ecus: [],
        assemblyParts: [],
        manufacturerSoftwareVersions: [],
        manufacturerSoftwareNumbers: [],
        supplierSoftwareVersions: [],
        dtcCodes: [],
        decCodes: [],
        ecusOthers: [],
        assemblyPartsOthers: [],
        manufacturerSoftwareVersionsOthers: [],
        manufacturerSoftwareNumbersOthers: [],
        supplierSoftwareVersionsOthers: [],
        dtcCodesOthers: [],
        decCodesOthers: []
      },
      dateAndMileage: {
        raw: {
          readoutDateFrom: '',
          readoutDateTo: '',
          dwSaveDateFrom: '',
          dwSaveDateTo: '',
          mileageReadoutFrom: null,
          mileageReadoutTo: null,
          includeVehiclesSinceStart: false,
          maximumLoss: null
        },
        formatted: {
          readoutDateFrom: '',
          readoutDateTo: '',
          dwSaveDateFrom: '',
          dwSaveDateTo: '',
          mileageReadoutFrom: null,
          mileageReadoutTo: null,
          includeVehiclesSinceStart: false,
          maximumLoss: null
        }
      }
    }
  },
  mutations: {
    signals (state, payload) {
      state.signals[payload.prop] = payload.value
    },
    selected (state, payload) {
      state.selected[payload.prop] = payload.value
    },
    allEcusSelected (state, payload) {
      state.allEcusSelected = payload
    },
    overwriteSelected (state, newVal) {
      state.selected = newVal
    },
    setDefaultState (state) {
      state.allEcusSelected = false
      state.signals = {
        options: [],
        loading: false,
        error: false
      }
    },
    setDefaultSelectionState (state) {
      state.selected = {
        signals: [],
        customReportLink: null,
        ecuTypeActive: '',
        ecuProperties: {
          ecus: [],
          assemblyParts: [],
          manufacturerSoftwareVersions: [],
          manufacturerSoftwareNumbers: [],
          supplierSoftwareVersions: [],
          dtcCodes: [],
          decCodes: [],
          ecusOthers: [],
          assemblyPartsOthers: [],
          manufacturerSoftwareVersionsOthers: [],
          manufacturerSoftwareNumbersOthers: [],
          supplierSoftwareVersionsOthers: [],
          dtcCodesOthers: [],
          decCodesOthers: []
        },
        dateAndMileage: {
          raw: {
            readoutDateFrom: '',
            readoutDateTo: '',
            dwSaveDateFrom: '',
            dwSaveDateTo: '',
            mileageReadoutFrom: null,
            mileageReadoutTo: null,
            includeVehiclesSinceStart: false,
            maximumLoss: null
          },
          formatted: {
            readoutDateFrom: '',
            readoutDateTo: '',
            dwSaveDateFrom: '',
            dwSaveDateTo: '',
            mileageReadoutFrom: null,
            mileageReadoutTo: null,
            includeVehiclesSinceStart: false,
            maximumLoss: null
          }
        }
      }
    }
  },
  getters: {
    isAllEcusSelected: state => {
      return state.allEcusSelected
    },
    getAllSelections: state => {
      return state.selected
    }
  },
  actions: {
    loadStateFromFile ({ commit, dispatch }, data) {
      commit('overwriteSelected', data)
      dispatch('loadSignals')
    },
    loadSignals ({ state, commit, getters, rootGetters }) {
      commit('signals', { prop: 'loading', value: true })
      commit('signals', { prop: 'error', value: false })
      const ecuList = getters['freezeFramesReport/isAllEcusSelected'] ? [{ id: 'ALL' }] : (state.selected.ecuProperties.ecus.map(item => ({ id: item }))).concat(state.selected.ecuProperties.ecusOthers?.map(item1 => ({ id: item1 })))
      if (ecuList.length === 0) {
        commit('signals', { prop: 'options', value: [] })
        return
      }
      const featureToogle = () =>{
        if(store.state.population.productType.toUpperCase() === 'VEHICLE')return  vehicleSignalNamesByEcus()
        if(store.state.population.productType.toUpperCase() === 'ENGINES')return  engineSignalNamesByEcus()  
      }
      featureToogle().then(response => {
         //Appending variables types based on ecu list 
        var signalNamesByEcu = []
        ecuList.forEach((ecu) => {
          signalNamesByEcu.push(...response.filter(object => object['EcuApplication'] === ecu.id))
        }
      )
      commit('signals', {
        prop: 'options',
        value: signalNamesByEcu.map(x => ({
          id: x.UniqueSignalNameIdentifier,
          label: x.UniqueSignalNameIdentifier,
          key: x.EcuApplication
        }))
      })
      }).catch(error => {
        console.error('FreezeFrames:getSignalNamesByEcus: ', error)
        commit('signals', { prop: 'error', value: true })
      }).finally(() => {
        commit('signals', { prop: 'loading', value: false })
      })
    },
    updateSelection ({ commit }, payload) {
      if (payload.propName) payload.prop = payload.propName // TODO: Harmonize payload interfaces
      commit('selected', payload)
    },
    syncSignalsWithEcus ({ commit, state }) {
      const selectedEcus = (state.selected.ecuProperties.ecus).concat(state.selected.ecuProperties?.ecusOthers)
      commit('signals', {
        prop: 'options',
        value: state.signals.options.filter(signal => selectedEcus.includes(signal.key))
      })
      commit('selected', {
        prop: 'signals',
        value: state.selected.signals.filter(signal => selectedEcus.includes(signal.key))
      })
    },
    reset ({ commit }) {
      // commit('setDefaultState')
      commit('setDefaultSelectionState')
    }
  }
}
export default freezeFrames
